// Tipos de roles de usuário
export type UserRole = 'user' | 'commercial' | 'admin';

// Interface do usuário
export interface IUser {
  id: string;
  name: string;
  email: string;
  phone?: string;
  roles: UserRole[];
  affiliate_code: string;
}

// Interface do cliente
export interface IClient {
  id: string;
  name: string;
  email: string;
  phone: string;
  status: ClientStatus;
  assigned_at?: string;
  created_at: string;
  affiliate?: {
    id: string;
    name: string;
    email: string;
    code: string;
  };
  commercial?: {
    id: string;
    name: string;
    email: string;
  };
}

// Status do cliente (lead)
export type ClientStatus =
  | 'pending_contact'
  | 'call_scheduled'
  | 'no_show'
  | 'not_interested'
  | 'did_not_buy'
  | 'bought';

// Labels dos status
export const CLIENT_STATUS_LABELS: Record<ClientStatus, string> = {
  pending_contact: 'Pendente de Contato',
  call_scheduled: 'Call Agendada',
  no_show: 'No-Show',
  not_interested: 'Sem Interesse',
  did_not_buy: 'Não comprou',
  bought: 'Comprou!',
};

// Cores dos status
export const CLIENT_STATUS_COLORS: Record<ClientStatus, 'warning' | 'info' | 'success' | 'error'> = {
  pending_contact: 'warning',
  call_scheduled: 'info',
  no_show: 'warning',
  not_interested: 'error',
  did_not_buy: 'error',
  bought: 'success',
};

// Interface de log do cliente
export interface IClientLog {
  id: string;
  action: string;
  description: string;
  previous_value?: any;
  new_value?: any;
  metadata?: any;
  performed_by?: {
    id: string;
    name: string;
  };
  created_at: string;
}

// Status de pagamento
export type PaymentStatus = 'pending' | 'paid' | 'cancelled';

// Labels dos status de pagamento
export const PAYMENT_STATUS_LABELS: Record<PaymentStatus, string> = {
  pending: 'Pendente',
  paid: 'Pago',
  cancelled: 'Cancelado',
};

// Cores dos status de pagamento
export const PAYMENT_STATUS_COLORS: Record<PaymentStatus, 'warning' | 'success' | 'error'> = {
  pending: 'warning',
  paid: 'success',
  cancelled: 'error',
};

// Interface de pagamento
export interface IPayment {
  id: string;
  commission_value: number;
  status: PaymentStatus;
  paid_at?: string;
  notes?: string;
  cancelled_at?: string;
  cancellation_reason?: string;
  created_at: string;
  client?: {
    id: string;
    name: string;
    email: string;
    phone: string;
  };
  affiliate?: {
    id: string;
    name: string;
    email: string;
    code: string;
  };
  commercial?: {
    id: string;
    name: string;
    email: string;
  };
  paid_by?: {
    id: string;
    name: string;
  };
  cancelled_by?: {
    id: string;
    name: string;
  };
}

// Interface de configurações
export interface ISettings {
  client_discount: number;
  client_discount_type: 'fixed' | 'percentage';
}

// Interface do dashboard do usuário
export interface IUserDashboard {
  user: IUser;
  affiliate_link: string;
  commission: {
    value: number;
  };
  client_discount: {
    value: number;
    type: 'fixed' | 'percentage';
  };
  stats: {
    total_clients: number;
    closed_clients: number;
  };
}

// Labels das roles
export const ROLE_LABELS: Record<UserRole, string> = {
  user: 'Indicação',
  commercial: 'Comercial',
  admin: 'Administrador',
};
